import { render, staticRenderFns } from "./VistaURLInteres.vue?vue&type=template&id=83cac66a&scoped=true"
import script from "./VistaURLInteres.vue?vue&type=script&lang=js"
export * from "./VistaURLInteres.vue?vue&type=script&lang=js"
import style0 from "./VistaURLInteres.vue?vue&type=style&index=0&id=83cac66a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83cac66a",
  null
  
)

export default component.exports